<template lang="pug">
#app(style="height: 100%; padding: 24px 24px 0px 24px; max-height: calc(100vh - 112px - var(--env-banner-height, 0px)); position: relative; display: flex; flex-direction: column; overflow: hidden")
    WarningSelect(v-show="!estabelecimentoSelecionado")
    v-layout(row, wrap, v-if="estabelecimentoSelecionado")
      v-flex.pb-0(lg12)
          v-layout(row, wrap)
            v-flex.md6
              v-btn.br-5.ml-0(
                  class="botaoEdicao",
                  slot="activator",
                  :color="corBotao",
                  height="33px",
                  :disabled="!$root.user.permissao_cardapio",
                  prepend-inner-icon="mdi mdi-chevron-down",
                  @click="ativarEdicao()",
                  depressed
                )
                  span.square-icon.custom-color(:style="{ 'background-color': corDentroBotao }")
                    i.fa.fa-check.white--text.transformation(v-show="editarCardapio")
                  | {{ editarCardapio ? 'Edição habilitada' : 'Habilitar edição'}}

            v-flex.md6(:class="{ 'pr-5': !mobile }")
              v-btn.br-5.right.mr-0(
                slot="activator",
                color="gray lighten-5",
                height="33px",
                :href="$root.getURL(estabelecimentoSelecionado)",
                target="_blank",
                depressed
              )
                span.square-icon.custom-color.Poppins(class="introbotaoHover",)
                  i.fa.fa-arrow-up.iconSetaPraCima
                | Ver Loja
          v-layout(row, wrap, :class="{ 'pr-5': !mobile }")
            v-flex.md7
                v-text-field.Poppins.icon-green.inputDefault(
                  label="Ingrediente, Produto...",
                  color="primary",
                  v-model="search",
                  clearable,
                  outline,
                  :loading="buscando",
                  :hide-details="true"
                  prepend-inner-icon="search"
                )
            v-flex.xs12.md5.text-xs-right(:class="{ 'd-flex': mobile }")
              v-btn.br-5.mt-2(
                :class="{ 'mx-0': !mobile }"
                :disabled="!($root.user.permissao_cardapio && editarCardapio)"
                @click="openDialogOrdenacao()",
                depressed,
                large,
                color="gray lighten-5",
              )
                i.my-0(:style="{'color': editarCardapio ? 'black' : 'gray'}").pl-1.mr-2.fa.fa-exchange.btnReordenar
                span Reordenar Itens

              v-btn.br-5.mt-2(
                large,
                :class="{ 'mr-0': !mobile }",
                color="primary",
                @click="!mobile ? openDialogCategoria() : openDialogMobileCategoria(); $refs.dialogItem.ocultarItem(); itemSelecionado=true; cadastroAtual = 1;",
                :disabled="!($root.user.permissao_cardapio && editarCardapio)"
                depressed
              )
                i(:style="{'color': editarCardapio ? 'white' : 'gray'}").pl-2.mr-2.fa.fa-plus.iconAdicionarCategorias
                label(:style="{'color': editarCardapio ? 'white' : 'gray'}") Categoria

    v-layout(row, wrap, v-if="loadingCardapio && estabelecimentoSelecionado")
      v-flex.text-xs-center
        v-progress-linear(:indeterminate="true").ma-1

    //-Catalogo Simples
    v-layout.mt-2(row, wrap, v-if="estabelecimentoSelecionado", style="max-height: 100%;overflow-y: scroll; overflow-x: hidden")
      v-flex.md12.text-xs-center.mt-5(v-if="!catalogo && !loadingCardapio")
        .headline.font-weight-light Não há cardápio cadastrado!
      v-flex.md12(v-if="catalogo", style="height:100%;")
        v-flex.br-5.py-2()
          v-layout(row, wrap, v-if="list.length == 0 && search != '' && !buscando")
            v-flex.md12.text-xs-center.mt-5
              .headline.font-weight-medium.grey--text Desculpe, não encontramos o que você está procurando.
          v-card.card--flex-toolbar.mt-3(v-for="categoria in orderBy(list, 'indice', 'asc')", :key="categoria.id", :ref="`categoria${categoria.id}`", style="box-shadow:none; background-color: transparent;")
            v-toolbar.br-10.mr-2(
              card,
              prominent,
              height="80px"
              style="border: 1px solid rgba(17, 19, 18, 0.1);"
              :class="{ 'verdeCategoria lighten-2': categoria.ativo, 'vermelhoCategoria lighten-4': !categoria.ativo && categoriaAberta(categoria), 'vermelhoCategoriaFechada lighten-4': !categoria.ativo && !categoriaAberta(categoria) }")
              v-toolbar-title.title(@click.stop="!mobile ? openDialogCategoria(categoria) : openDialogMobileCategoria(categoria);",)
                div
                .title {{ categoria.nome }} {{ categoriaVigente(categoria) ? `(${categoria.percentual_desconto * 100}% OFF)` : '' }}
                .caption.mt-2 {{ categoria | turnos }}
                  label.caption.font-weight-bold(v-if="categoria.modelo_id",style="color:#007AFF !important;")  - Integrada
                  label.caption(style="color: rgba(17, 19, 18, 0.6);")  • {{ categoria.total_itens }} {{ categoria.total_itens == 1 ? 'item' : 'itens' }}
              v-spacer

              v-btn.Poppins.Capitalize.botaoAdicionarItem(
                v-if="!mobile"
                flat,
                color="primary",
                @click.stop="!mobile ? openDialogItem(null, categoria) : openDialogMobileItem(null, categoria); $refs.dialogCategoria.ocultarCategoria(); cadastroAtual = 2;",
                :disabled="!($root.user.permissao_cardapio && editarCardapio)"
              )
                | Adicionar Item
              v-flex.shrink
                v-btn(
                  flat,
                  icon,
                  color="primary",
                  density="compact",
                  @click="mostratItensCategoria(categoria)"
                  )
                  i.pl-2.fa.fa-chevron-down(
                    style="padding:0px !important;transition: 0.5s cubic-bezier(0, 1.1, 0.2, 1);",
                    :class="categoriaAberta(categoria) ? 'rotate-180' : 'rotate-0'"
                  )
              v-flex.shrink(:disabled="$root.user.permissao_cardapio && editarCardapio && categoria.modelo_id == null")
                v-menu(offset-y)
                  template(v-slot:activator="{ on, attrs }")
                    v-btn(flat, icon, v-bind="attrs", v-on="on", color="primary")
                      i.fa.fa-ellipsis-v
                  v-list.Poppins(style="display: flex; flex-wrap: nowrap; justify-content: center; align-items: center; flex-direction: column; font-size: 15px;")
                    v-list-tile
                      v-btn.Poppins.Capitalize.ma-0.pl-0.pr-0(flat, :disabled="categoria.campanha == 1 || loading || !($root.user.permissao_cardapio && editarCardapio)", @click="ativarCategoria(categoria)")
                        | {{ categoria.ativo ? 'Desativar' : 'Ativar' }}
                    v-list-tile
                      v-btn.Poppins.Capitalize.ma-0.pl-0.pr-0(flat, @click="openDialogCategoria(categoria)", :disabled="categoria.campanha == 1 || !($root.user.permissao_cardapio && editarCardapio) || (categoria.modelo_id != null)")
                        | Editar
                    v-list-tile(v-if="mobile")
                      v-btn.Poppins.Capitalize.ma-0.pl-0.pr-0(flat, @click="!mobile ? openDialogItem(null, categoria) : openDialogMobileItem(null, categoria); $refs.dialogCategoria.ocultarCategoria(); cadastroAtual = 2;",
                      :disabled="categoria.campanha == 1 || !($root.user.permissao_cardapio && editarCardapio)")
                        | Adicionar Item
                    v-list-tile
                      v-btn.Poppins.Capitalize.ma-0.pl-0.pr-0(flat, @click="openDialogMoverItens(categoria)", :disabled="!categoria.total_itens || !($root.user.permissao_cardapio && editarCardapio)")
                        | Mover itens

            //- Itens da Categoria
            div.md1(v-show="categoriaAberta(categoria)")
              div(v-for="item in itensVisiveis(categoria)", :key="item.id",:class="{ 'circulating-border': isClicked === item.id }" @click="startAnimation(item.id)")
                v-card-text(
                  :class="{ 'vermelhoItem lighten-4': (!item.ativo || !categoria.ativo || !item.disponivel || promoEspirada(item))}"
                  @click="!mobile ? openDialogItem(item, categoria) : openDialogMobileItem(item, categoria)",
                  style="cursor: pointer"
                )
                  //- Area dos Itens e Suas Informações
                  v-layout(row, wrap, align-center)
                    v-flex.md1.xs2
                      v-switch(
                        inset
                        color="primary",
                        :input-value="isAtivo(item)",
                        :key="item.id"
                        :disabled="loading || !($root.user.permissao_cardapio) || !editarCardapio",
                        @click.stop="isAtivo(item) ? openDialogDesativarItem(item) : ativarItem(item)",
                      )
                    v-flex.md2.xs3(v-if="!mobile")
                      img.rounded-10(
                        style="max-width:80px;"
                        :src="item.imagem ? `${urlImagem}/item/${item.imagem}` : require('@/assets/images/invalidImage.svg')",
                        aspect-ratio="1/1",
                        cover="true"
                      )
                    v-flex.md6.xs6.Poppins
                      .subheading.d-flex(style="font-weight:600;color:rgba(17, 19, 18, 0.8);") {{ item.nome }}
                          //- Adição das etiquetas caso mobile
                          span.d-flex.align-items-center
                            img.ml-2(
                              v-if="isIntegrado(item) && mobile",
                              :src="require('@/assets/images/integrated.svg')"
                              style="max-width:15px;"
                            )
                            img.ml-2(
                              v-if="verifyPromoSpecialItem(item) && mobile",
                              :src="require('@/assets/images/ticket.svg')"
                              style="max-width:15px;"
                            )
                            img.ml-2(
                              v-if="item.promocional && !itemVigente(item) && !item.fixo && mobile",
                              :src="require('@/assets/images/time.svg')"
                              style="max-width:15px;"
                            )
                            img.ml-2(
                              v-if="!item.disponivel && item.data_disponivel && mobile",
                              :src="require('@/assets/images/alert.svg')"
                              style="max-width:15px;"
                            )
                      //-Continuação da Descrição
                      .mt-1(style="color: rgba(17, 19, 18, 0.6);") {{ item.descricao && item.descricao.length > 100 ? (mobile ? item.descricao.slice(0, 30) + '...' : item.descricao.slice(0, 100) + '...') : (item.descricao ? (mobile ? item.descricao.slice(0, 30) + '...' : item.descricao) : '') }}
                      .caption.font-weight-bold.Capitalize(v-if="isIntegrado(item)",style="color:rgba(17, 19, 18, 0.6);") {{item.cod_bar}}
                        span(v-if="isIntegrado(item) && item.pdv",style="color:#9300ff;") {{" - PDV: " + item.pdv}}
                      span(v-if="!isIntegrado(item) && item.pdv",style="color:#9300ff;") {{"PDV: " + item.pdv}}
                      br
                      span(v-if="!isIntegrado(item)").mt-1.caption.Capitalize.font-weight-regular.grey--text Disponível {{ item.disponibilidade_diaria | disponibilidade }}

                    v-flex.md3.xs4.text-xs-center.pl-0(style="position:relative;")
                      .headline.font-weight-bold.Poppins(
                        v-if="!item.promocional || (item.promocional && !itemVigente(item) && item.fixo)"
                      )
                        span.font-weight-bold.primary--text {{ item.preco | currency }}
                      span(
                        v-if="item.promocional && (itemVigente(item) || (!itemVigente(item) && !item.fixo))"
                      )
                        div.body-1.preco-promocional.Poppins
                          span.font-weight-medium(style="color: #CE2E2E;font-weight: 500;") {{ ((item.preco - item.preco_promocional) / item.preco * 100).toFixed(0) }}%
                          span.font-weight-bold(style="text-decoration-line: line-through; color: rgba(17, 19, 18, 0.4);") {{ item.preco | currency }}

                        div.headline.font-weight-bold.Poppins
                          span.primary--text {{ item.preco_promocional | currency }}
                      div.btnDeletar
                        v-btn(
                          flat,
                          icon,
                          density="compact",
                          v-show="editarCardapio && !item.cod_bar",
                          :disabled="loading || !($root.user.permissao_cardapio && editarCardapio)",
                          title="Mover para outra categoria",
                          @click.stop="openDialogMoverItem(item, categoria)",
                          color="primary"
                          )
                            i.fa.fa-arrows(style="font-size:18px;")
                        v-btn(
                          flat,
                          icon,
                          density="compact",
                          font-weight-bold,
                          v-show="!isAtivo(item) && editarCardapio",
                          :disabled="loading || !($root.user.permissao_cardapio && editarCardapio)",
                          @click="arquivarItem(item)",
                          color="#FF0F00"
                          )
                            img(
                                :src="require('@/assets/images/iconTrash.svg')"
                                style="width:20px;"

                              )
                  v-divider(color="gray",style="opacity:0.2;", v-if="mobile")
                  v-layout(
                    row,
                    wrap,
                    v-if="isIntegrado(item) || verifyPromoSpecialItem(item) || item.promocional && !itemVigente(item) && !item.fixo || !item.disponivel && item.data_disponivel"
                  )
                    v-flex.xs3.pa-0(v-if="!mobile")
                    v-flex.xs9.pa-0.pl-3(:class="{ 'tagsIntegrado': isIntegrado(item)}", style="transform: translateX(-3px);")
                      //-Tag de Integração
                      v-chip.ml-0(
                        v-if="isIntegrado(item) && !mobile",
                        outline,
                        color="#007AFF",
                        style="height:20px;"
                      )
                        v-avatar.mr-0
                          img(
                              :src="require('@/assets/images/integrated.svg')"
                              style="width:15px;"
                            )
                        div.caption.integrado.font-weight-medium Integrado

                      //-Tag de Promoção Especial
                      v-chip.ml-0(
                        v-if="verifyPromoSpecialItem(item) && !mobile",
                        outline,
                        color="#E65300",
                        style="height:20px;"
                      )
                        v-avatar.mr-0
                          img(
                            :src="require('@/assets/images/ticket.svg')"
                            style="width:15px;"
                          )
                        div.caption(
                          style="font-weight:500;font-size:12px;"
                        ) Promoção Especial

                      //-Tag de Promoção Expirada
                      v-chip.ml-0(
                        v-if="promoEspirada(item) && !mobile",
                        outline,
                        color="#CE2E2E",
                        style="height:20px;"
                      )
                        v-avatar.mr-0
                          img(
                              :src="require('@/assets/images/time.svg')"
                              style="width:15px;"
                            )
                        div.caption(
                          style="font-weight:500;font-size:12px;"
                        ) Promoção Expirada {{ $dayjs(item.data_fim).format('DD/MM/YYYY [•] HH:mm') }}

                      //-Tag de Indisponíbilidade
                      v-chip.ml-0(
                        v-if="!item.disponivel && item.data_disponivel && !mobile",
                        outline,
                        color="#CE2E2E",
                        style="height:20px;"
                      )
                        v-avatar.mr-0
                          img(
                              :src="require('@/assets/images/alert.svg')"
                              style="width:15px;"
                            )
                        div.caption.font-weight-medium Indisponível até {{ $dayjs(item.data_disponivel).format('DD/MM/YYYY') }}

              //- Paginação da categoria — cada página busca só os seus itens
              div.text-xs-center.py-3(v-if="!modoBusca && (categoria.carregando || totalPaginas(categoria) > 1)")
                v-progress-circular(v-if="categoria.carregando", indeterminate, color="primary", size="24")
                template(v-else)
                  v-pagination(
                    :value="categoria.pagina",
                    :length="totalPaginas(categoria)",
                    :total-visible="mobile ? 5 : 9",
                    color="primary",
                    @input="pagina => trocarPagina(categoria, pagina)"
                  )
                  .caption.mt-2(style="color: rgba(17, 19, 18, 0.6);") {{ intervaloPagina(categoria) }}

      v-card.card--flex-toolbar.mt-0(
        v-if="catalogo && !mobile")
        v-navigation-drawer(
          disable-resize-watcher
          right
          temporary
          :permanent="!!travarClose"
          clipped
          persistent
          fixed
          width="1920"
          height="1920"
          v-model="mostrarBarraLateral"
          style="padding:0px !important;max-width: 50vw;overflow: hidden;",
        )
          v-card.card--flex-toolbar.mt-0.br-5(
            style="max-height: calc(100vh - var(--env-banner-height, 0px));box-shadow:none !important;overflow-y: auto;background-color:#EAEAEA ")
              v-flex.xs12.pa-0
                v-flex.areaSalvar.br-10(v-show="editarCardapio && $root.user.permissao_cardapio && !mobile && cadastroAtual!= null")
                  v-btn.botaoSalvarGeral(
                        color="primary",
                        @click="salvarGeral(); travarClose = false;",
                        depressed
                      )
                        i.mr-2.fa.fa-plus
                        | Salvar alterações
                v-btn.ml-4(
                  color="#C0C0C0",
                  @click="mostrarBarraLateral = !mostrarBarraLateral; travarClose = false;",
                  depressed,
                  icon
                  )
                    i.fa.fa-plus.iconAdicionarCategorias(style="color:rgba(0,0,0,0.56);font-size:20px;transform:rotate(45deg);")

                v-btn.right.mr-4.br-5(
                  class="botaoEdicao",
                  slot="activator",
                  :color="corBotao",
                  height="33px",
                  :disabled="!$root.user.permissao_cardapio",
                  prepend-inner-icon="mdi mdi-chevron-down",
                  @click="ativarEdicao()",
                  depressed
                )
                  span.square-icon.custom-color(:style="{ 'background-color': corDentroBotao }")
                    i.fa.fa-check.white--text.transformation(v-show="editarCardapio")
                  | {{ editarCardapio ? 'Edição habilitada' : 'Habilitar edição'}}
                v-btn.right.mr-4.br-5(
                    class="botaoCompartilhar",
                    slot="activator",
                    height="33px",
                    :disabled="!canShareSelectedItem()",
                    @click="shareSelectedItem()",
                    depressed
                  )
                    span.square-icon.custom-color
                      i.fa.fa-share-alt.gray--text
                    | Compartilhar
                v-btn.right.mr-4.br-5(
                    class="botaoDuplicar",
                    height="33px",
                    :disabled="!podeDuplicarItemSelecionado()",
                    :loading="duplicando",
                    @click="duplicarItemSelecionado()",
                    depressed
                  )
                    span.square-icon.custom-color
                      i.fa.fa-clone.gray--text
                    | Duplicar
              dialogItem(ref="dialogItem", @refresh-itens="refreshList", @change-travaclose="alteraTravaClose")
              dialogCategoria(ref="dialogCategoria")
              dialogOrdenacao(ref="dialogOrdenacao")
              dialogDesativarItem(ref="dialogDesativarItem", @refresh-itens="refreshList")

      v-card.card--flex-toolbar.mt-0(
        v-if="catalogo && mobile"
        style="height: 70vh;box-shadow:none !important;")
        v-flex.areaSalvarMobile.br-10(v-if="editarCardapio && mostrarBarraLateral && $root.user.permissao_cardapio && mobile && itemSelecionado != false && cadastroAtual!= null")
          v-btn.botaoSalvarGeral(
            color="primary",
            @click="salvarGeral(); travarClose = false;",
            depressed
          )
            i.mr-2.fa.fa-plus
            | Salvar alterações
        v-navigation-drawer(
          disable-resize-watcher
          right
          fixed
          width="1920"
          height="1920"
          :permanent="!!travarClose"
          v-model="mostrarBarraLateral"
          style="padding:0px !important;"
        )
          v-card.card--flex-toolbar.mt-0.br-5(
            style="height: calc(100vh - var(--env-banner-height, 0px));box-shadow:none !important;overflow-y: auto;")
              v-flex.xs12.pa-0
                v-btn.ml-4(
                  color="#e8e8ed",
                  @click="mostrarBarraLateral = !mostrarBarraLateral; travarClose = false;",
                  depressed,
                  icon
                  )
                    i.fa.fa-plus.iconAdicionarCategorias(style="color:rgba(0,0,0,0.56);font-size:20px;transform:rotate(45deg);")

                v-btn.right.mr-4.br-5(
                  class="botaoEdicao",
                  slot="activator",
                  :color="corBotao",
                  height="33px",
                  :disabled="!$root.user.permissao_cardapio",
                  prepend-inner-icon="mdi mdi-chevron-down",
                  @click="ativarEdicao()",
                  depressed
                )
                  span.square-icon.custom-color(:style="{ 'background-color': corDentroBotao }")
                    i.fa.fa-check.white--text.transformation(v-show="editarCardapio")
                  | {{ editarCardapio ? 'Edição habilitada' : 'Habilitar edição'}}
                v-btn.right.mr-2.br-5(
                  class="botaoDuplicar",
                  height="33px",
                  :disabled="!podeDuplicarItemSelecionado()",
                  :loading="duplicando",
                  @click="duplicarItemSelecionado()",
                  depressed
                )
                  span.square-icon.custom-color
                    i.fa.fa-clone.gray--text
                  | Duplicar
              dialogItem(ref="dialogItem", @refresh-itens="refreshList", @change-travaclose="alteraTravaClose")
              dialogCategoria(ref="dialogCategoria")
              dialogOrdenacao(ref="dialogOrdenacao")
              dialogDesativarItem(ref="dialogDesativarItem", @refresh-itens="refreshList")
    //-Fim da Importação do Catalogo Simples
    dialogMoverItens(ref="dialogMoverItens", @itens-movidos="onItensMovidos")
    OnboardingFab(etapa="etapa_cardapio")

</template>

<script>
import dialogCategoria from "@/pages/cardapio/dialog/Categoria";
import dialogItem from "@/pages/cardapio/dialog/Item";
import dialogOrdenacao from "@/pages/cardapio/dialog/Ordenacao";
import dialogDesativarItem from "@/pages/cardapio/dialog/DesativarItem";
import dialogMoverItens from "@/pages/cardapio/dialog/MoverItens";
import WarningSelect from '@/components/WarningSelect';
import OnboardingFab from '@/components/OnboardingFab';


import _ from "lodash";
import Vue2Filters from "vue2-filters";

const TAMANHO_PAGINA = 50;
const LIMITE_CATALOGO_GRANDE = 200;
const MIN_CARACTERES_BUSCA = 2;

export default {
  mixins: [Vue2Filters.mixin],
  $_veeValidate: {
    validator: "new",
  },
  components: {
    dialogCategoria,
    dialogItem,
    dialogOrdenacao,
    dialogDesativarItem,
    dialogMoverItens,
    WarningSelect,
    OnboardingFab,
  },
  data: () => ({
    editarCardapio: false,
    loadingCardapio: false,
    catalogo: null,
    lista: {},
    corBotao: null,
    corDentroBotao: null,
    loading: false,
    dialogOrdenacao: false,
    dialogCategoria: false,
    dialogItem: false,
    categorias: [],
    search: "",
    buscando: false,
    resultadoBusca: null,
    buscaToken: 0,
    ocultarCategoria: [],
    isClicked: null,
    imagem: null,
    switchAtivo: {},
    mobile: null,
    ocultarBotoesHeader: null,
    mostrarBarraLateral:false,
    travarClose: false,
    itemSelecionado:false,
    cadastroAtual: null, // 1 = Categoria, 2 = ItemGeral
    searched: false,
    duplicando: false
  }),
  mounted() {
    this.onChangeEstabelecimento();
    this.syncCardapio();
  },
  watch: {
    mostrarBarraLateral(value) {
      if (value) {
        document.documentElement.classList.add('no-scroll');
        setTimeout(() => {
          const leitorInputs = document.querySelector('.LeitorInputs');
          if (leitorInputs) {
            leitorInputs.addEventListener('click', this.handleInputClick);
          }
        }, 100);
      } else {
        document.documentElement.classList.remove('no-scroll');
      }
    },
    editarCardapio(val) {
      if (val) this.saveLog();
      this.setEditable(val);
      this.corBotao = val ? "#E3F0E9" : "#EAEAEA";
      this.corDentroBotao = val ? this.$root.colors.primary : "#C7C7C7";
    },
    search: _.debounce(function (termo) {
      this.buscar(termo);
    }, 400),
  },
  computed: {
    modoBusca() {
      return !!(this.search && this.search.trim().length >= MIN_CARACTERES_BUSCA);
    },
    list() {
      if (!this.modoBusca) {
        return this.categorias;
      }

      const termo = this.normalizar(this.search);

      return this.categorias.filter(categoria => {
        const resultados = this.resultadoBusca ? this.resultadoBusca[categoria.id] : null;

        return (resultados && resultados.length > 0) || this.normalizar(categoria.nome).includes(termo);
      });
    },
    urlImagem(){
      return process.env.VUE_APP_IMAGE_URL;
    },
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
  },
  created() {
    if (process.browser) {
      window.addEventListener("resize", this.checkScreen);
      this.checkScreen();
    }

    window.getApp.$on("CHANGE_ESTABELECIMENTO",this.onChangeEstabelecimento);
  },
  beforeDestroy() {
    window.getApp.$off("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  methods: {
    onChangeEstabelecimento(){
      console.log('CHANGE_ESTABELECIMENTO CATÁLOGO', this.estabelecimentoSelecionado)
      if(this.estabelecimentoSelecionado){
        this.init();
        this.catalogo = null;
        this.categorias = [];
        this.editarCardapio = false;
        this.search = "";
        this.resultadoBusca = null;
      }
    },
    syncCardapio(){
      this.ocultarCategoria = this.$root.cardapio || [];
    },
    promoEspirada(item){
      return item.promocional && !this.itemVigente(item) && !item.fixo;
    },
    handleInputClick(event) {
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.closest('.iconDeletar')) {
        this.travarClose = true;
      }
    },
    init(){
      this.$root.editarCardapio = false;
      this.corBotao = "#EAEAEA";
      this.corDentroBotao = "#C7C7C7";
      this.getCatalogo();
    },
    alteraTravaClose(val){
      this.travarClose = val;
    },
    async salvarGeral(){
      if(this.cadastroAtual === 1){ // Categoria
        const validation = await this.$refs.dialogCategoria.validate();
        if (validation) {
            this.mostrarBarraLateral = false;
            return validation;
        }
      }else if(this.cadastroAtual === 2){ //Geral Item
        if(this.$refs.dialogItem.item.id){
          const validation = this.$refs.dialogItem.activetab === 1 ? (await this.$refs.dialogItem.validate('item')) : true;
          const validationTwo = this.$refs.dialogItem.activetab === 3 ? (await this.$refs.dialogItem.validate('item3')) : true;
          if (validation && validationTwo) {
            return validation, validationTwo;
          }
        }else{
          const validation = await this.$refs.dialogItem.validate('item')
          if (validation) {
            return validation;
          }
        }
      }else{
        return window.getApp.$emit("APP_ALERT", {
        color: "red",
        text: "alteração não pode ser salva",
      });
      }
    },
    ativarEdicao() {
      this.editarCardapio = !this.editarCardapio
      this.$refs.dialogItem.isEditor(this.editarCardapio);
      this.$refs.dialogCategoria.isEditor(this.editarCardapio);
    },
    checkScreen() {
      if(!this.mostrarBarraLateral){
        this.isClicked = null;
        this.itemSelecionado = null;
      }
      this.windowWidth = window.innerWidth;
      if (this.windowWidth <= 960) {
        this.mobile = true;
        this.$root.mobile = this.mobile
        this.ocultarBotoesHeader = false;
        return;
      }
      if (this.windowWidth > 960 && this.windowWidth <= 1650) {
        this.ocultarBotoesHeader = true;
        this.mobile = false;
        this.$root.mobile = this.mobile
        return;
      }
      this.ocultarBotoesHeader = false;
      this.mobile = false;
      this.$root.mobile = this.mobile
      return;
    },
    async saveLog() {
      await this.$axios.post("/log", {
        estabelecimento_id: this.estabelecimentoSelecionado.id,
        admin_estabelecimento_id: this.$root.user.id,
        registro: "CARDAPIO",
        alteracao: "Habilitou edição de cardápio no gestor de pedidos web",
      });
    },
    async getCatalogo() {
      try {
        if (!this.estabelecimentoSelecionado) return;
        this.loadingCardapio = true;
        const response = await this.$axios.get("/catalogo", {
          params: {
            estabelecimento_id: this.estabelecimentoSelecionado.id,
          },
        });
        if (response.data[0]) {
          this.catalogo = response.data[0];
          await this.setCatalogo(this.catalogo);
        }
        this.loadingCardapio = false;
      } catch (error) {
        console.log(error);
        let err =
          error.response && error.response.data
            ? error.response.data.error
            : "Ocorreu um erro ao carregar o cardápio. Tente novamente!";
        window.getApp.$emit("APP_ALERT", { color: "red", text: err });
        this.loadingCardapio = false;
      }
    },
    //-Funções e Metodos para a gerencia do Catalogo
    startAnimation(itemId) {
      if (this.isClicked === itemId) {
        this.isClicked = null; // Remove a classe se o mesmo item for clicado novamente
        this.mostrarBarraLateral = false;
      } else {
        this.isClicked = itemId; // Adiciona a classe para o novo item clicado
      }
    },
    async mostratItensCategoria(categoria) {
      categoria.aberta = !categoria.aberta;
      this.persistirEstadoCategoria(categoria);

      if (categoria.aberta) {
        await this.carregarPagina(categoria, categoria.pagina);
      }
    },
    categoriaAberta(categoria) {
      return this.modoBusca || categoria.aberta;
    },
    // Na busca mostra o resultado do servidor. Fora dela, só a página atual: quando o
    // catálogo inteiro já está em memória (loja pequena) a página é uma fatia local,
    // senão allItens já contém exatamente os itens da página que foi buscada.
    itensVisiveis(categoria) {
      if (this.modoBusca) {
        const resultados = this.resultadoBusca ? this.resultadoBusca[categoria.id] : null;

        return resultados && resultados.length > 0 ? resultados : categoria.allItens;
      }

      if (!categoria.completo) {
        return categoria.allItens;
      }

      const inicio = (categoria.pagina - 1) * TAMANHO_PAGINA;

      return categoria.allItens.slice(inicio, inicio + TAMANHO_PAGINA);
    },
    totalItensCategoria(categoria) {
      return categoria.completo ? categoria.allItens.length : categoria.total_itens;
    },
    totalPaginas(categoria) {
      return Math.max(1, Math.ceil(this.totalItensCategoria(categoria) / TAMANHO_PAGINA));
    },
    intervaloPagina(categoria) {
      const total = this.totalItensCategoria(categoria);
      const inicio = (categoria.pagina - 1) * TAMANHO_PAGINA + 1;
      const fim = Math.min(categoria.pagina * TAMANHO_PAGINA, total);

      return `Itens ${inicio} a ${fim} de ${total}`;
    },
    // Grava só a categoria alternada — como antes, para não inchar o estado persistido.
    persistirEstadoCategoria(categoria) {
      this.ocultarCategoria[categoria.id] = !categoria.aberta;
      this.$store.dispatch('setCardapio', this.ocultarCategoria);
    },
    normalizar(texto) {
      return String(texto || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    // Troca de página pedida pelo usuário: busca os itens e traz o topo da categoria de
    // volta à tela — senão ele continua olhando para o rodapé de uma lista que mudou.
    async trocarPagina(categoria, pagina) {
      const trocou = await this.carregarPagina(categoria, pagina);

      if (trocou) {
        this.rolarParaCategoria(categoria);
      }
    },
    rolarParaCategoria(categoria) {
      this.$nextTick(() => {
        const referencia = this.$refs[`categoria${categoria.id}`];
        const alvo = Array.isArray(referencia) ? referencia[0] : referencia;
        const elemento = alvo && alvo.$el ? alvo.$el : alvo;

        if (elemento && elemento.scrollIntoView) {
          elemento.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    // Troca a página exibida da categoria. A página anterior sai da memória e do DOM —
    // o custo da tela passa a ser de uma página, não do catálogo inteiro.
    async carregarPagina(categoria, pagina, { forcar = false } = {}) {
      const destino = Math.min(Math.max(1, pagina || 1), this.totalPaginas(categoria));

      // Loja pequena já tem tudo em memória: trocar de página é só mudar a fatia.
      if (categoria.completo) {
        categoria.pagina = destino;
        return true;
      }

      if (categoria.carregando) {
        return false;
      }

      if (!forcar && categoria.paginaCarregada === destino) {
        categoria.pagina = destino;
        return true;
      }

      categoria.carregando = true;

      try {
        const response = await this.$axios.get("/catalogo/item", {
          params: {
            categoria_id: categoria.id,
            status: 2,
            page: destino,
            totalPage: TAMANHO_PAGINA,
          },
        });

        // A contagem veio no carregamento da tela e pode estar defasada (outro operador
        // apagou itens). Página vazia significa categoria menor do que a contagem diz:
        // corrige o total e volta uma página, em vez de mostrar uma lista vazia.
        if (!response.data.length && destino > 1) {
          categoria.total_itens = (destino - 1) * TAMANHO_PAGINA;
          categoria.carregando = false;

          return await this.carregarPagina(categoria, destino - 1);
        }

        categoria.allItens = response.data;
        categoria.pagina = destino;
        categoria.paginaCarregada = destino;

        return true;
      } catch (error) {
        let err =
          error.response && error.response.data
            ? error.response.data.error
            : "Ocorreu um erro ao carregar os itens da categoria. Tente novamente!";
        window.getApp.$emit("APP_ALERT", { color: "red", text: err });
        return false;
      } finally {
        categoria.carregando = false;
      }
    },
    async carregarTodosItens(categoria) {
      if (categoria.completo) {
        return categoria.allItens;
      }

      categoria.carregando = true;

      try {
        const response = await this.$axios.get("/catalogo/item", {
          params: {
            categoria_id: categoria.id,
            status: 2,
          },
        });

        categoria.allItens = response.data;
        categoria.total_itens = response.data.length;
        categoria.completo = true;
        categoria.paginaCarregada = 0;
        categoria.pagina = Math.min(categoria.pagina, this.totalPaginas(categoria));
      } catch (error) {
        let err =
          error.response && error.response.data
            ? error.response.data.error
            : "Ocorreu um erro ao carregar os itens da categoria. Tente novamente!";
        window.getApp.$emit("APP_ALERT", { color: "red", text: err });
      } finally {
        categoria.carregando = false;
      }

      return categoria.allItens;
    },
    async setCatalogo(catalogo) {
      this.catalogo = catalogo;
      await this.getCategorias();
    },
    setEditable(bool) {
      this.editarCardapio = bool;
    },
    openDialogCategoria(categora) {
      this.cadastroAtual = 1;
      this.itemSelecionado = false;
      this.isClicked = null;
      this.mostrarBarraLateral = true;
      if(!categora){
        this.$refs.dialogItem.ocultarItem();//Caso seja uma criação ela entra aqui
        this.$refs.dialogCategoria.open(
          categora,
          this.categorias,
          this.catalogo
        );
        return;
      }

      if(this.itemSelecionado === categora.id){
        this.itemSelecionado = false;
        this.$refs.dialogItem.ocultarItem();
        this.$refs.dialogCategoria.ocultarCategoria();
      }else{
        this.$refs.dialogItem.ocultarItem();
        this.itemSelecionado = categora.id;
        this.$refs.dialogCategoria.open(
          categora,
          this.categorias,
          this.catalogo
        );
      }
    },

    openDialogItem(item, categoria) {
      this.cadastroAtual = 2;
      this.mostrarBarraLateral = true;
      this.$refs.dialogItem.delAfterSaveFunc(false);
      if(item){
        if(this.itemSelecionado === item.id){
          this.itemSelecionado = false;
          this.$refs.dialogItem.ocultarItem();
          this.$refs.dialogCategoria.ocultarCategoria();
        }else{
          this.$refs.dialogItem.resetMenu();
          this.$refs.dialogCategoria.ocultarCategoria();
          this.itemSelecionado = item.id;
          this.$refs.dialogItem.open(
            item,
            categoria,
            this.categorias,
            this.catalogo,
            );
        }
      }else{
        this.$refs.dialogItem.ocultarItem();
        this.$refs.dialogItem.open(
            item,
            categoria,
            this.categorias,
            this.catalogo,
            );
      }
    },
    openDialogMobileCategoria(categoria){
      this.mostrarBarraLateral = true;
      this.openDialogCategoria(categoria);
    },
    openDialogMobileItem(item, categoria){
      this.mostrarBarraLateral = true;
      this.openDialogItem(item, categoria);
    },
    openDialogOrdenacao() {
      this.$refs.dialogOrdenacao.open(this.categorias, this.carregarTodosItens);
    },
    openDialogDesativarItem(item) {
      console.log("Função de desativar");
      if (this.verifyPromoSpecialItem(item)) return this.showMsgPromoSpecial();
      this.$refs.dialogDesativarItem.open(item);
    },
    openDialogMoverItens(categoria) {
      this.$refs.dialogMoverItens.open({
        categoria,
        categorias: this.categorias,
        carregarItensCategoria: this.carregarTodosItens,
      });
    },
    openDialogMoverItem(item, categoria) {
      if (this.verifyPromoSpecialItem(item)) return this.showMsgPromoSpecial();
      this.$refs.dialogMoverItens.open({
        categoria,
        categorias: this.categorias,
        carregarItensCategoria: this.carregarTodosItens,
        item,
      });
    },
    onItensMovidos({ itens, origem, destino }) {
      const ids = itens.map(item => item.id);
      const movidos = itens.map(movido => Object.assign(this.encontrarItemCarregado(movido.id) || {}, movido));

      origem.allItens = origem.allItens.filter(item => !ids.includes(item.id));
      origem.total_itens = Math.max(0, origem.total_itens - ids.length);
      origem.pagina = Math.min(origem.pagina, this.totalPaginas(origem));

      if (destino.completo) {
        destino.allItens = destino.allItens.concat(movidos);
        destino.total_itens = destino.allItens.length;
      } else {
        destino.total_itens += ids.length;
      }

      [origem, destino].forEach(categoria => {
        if (!categoria.completo && categoria.paginaCarregada) {
          this.carregarPagina(categoria, categoria.pagina, { forcar: true });
        }
      });

      if (this.modoBusca) {
        this.buscar(this.search);
      }

      if (ids.includes(this.itemSelecionado)) {
        this.$refs.dialogItem.ocultarItem();
        this.itemSelecionado = false;
        this.isClicked = null;
        this.mostrarBarraLateral = false;
      }
    },
    isIntegrado(item) {
      return item.cod_bar && item.modelo_id;
    },
    isAtivo(item) {
      return item.ativo && item.disponivel;
    },
    refreshList(val) {
      this.categorias.forEach(categoria => {
        const itemIndex = categoria.allItens.findIndex(item => item.id == val.id);

        if (itemIndex != -1) {
          categoria.allItens[itemIndex] = val;
        }
      });

      this.$forceUpdate();
    },
    removerItemLocal(item) {
      this.categorias.forEach(categoria => {
        const indice = categoria.allItens.findIndex(atual => atual.id == item.id);

        if (indice === -1) {
          return;
        }

        categoria.allItens.splice(indice, 1);
        categoria.total_itens = Math.max(0, categoria.total_itens - 1);

        // Na lista paginada os itens seguintes sobem uma posição — a página aberta
        // precisa ser buscada de novo para não ficar com 49 itens e um buraco no fim.
        if (!categoria.completo) {
          this.carregarPagina(categoria, categoria.pagina, { forcar: true });
        }
      });

      if (this.resultadoBusca) {
        Object.keys(this.resultadoBusca).forEach(categoriaId => {
          this.resultadoBusca[categoriaId] = this.resultadoBusca[categoriaId].filter(
            atual => atual.id != item.id
          );
        });
      }
    },
    async getCategorias() {
      try {
        const response = await this.$axios.get("/catalogo/categoria", {
          params: {
            variacao: 0,
            catalogo_id: this.catalogo.id,
            fields: "contagem_itens"
          },
        });

        this.categorias = response.data.map(categoria => this.normalizarCategoria(categoria));

        const totalItens = this.categorias.reduce((total, categoria) => total + categoria.total_itens, 0);
        const catalogoGrande = totalItens > LIMITE_CATALOGO_GRANDE;

        this.definirEstadoInicialCategorias(catalogoGrande);

        if (catalogoGrande) {
          await Promise.all(
            this.categorias
              .filter(categoria => categoria.aberta && categoria.total_itens > 0)
              .map(categoria => this.carregarPagina(categoria, 1))
          );
        } else {
          await this.carregarCatalogoCompleto();
        }
      } catch (error) {
        let err =
          error.response && error.response.data
            ? error.response.data.error
            : "Ocorreu um erro ao carregar as categorias. Tente novamente!";
        window.getApp.$emit("APP_ALERT", { color: "red", text: err });
      }
      this.loading = false;
      // this.searched = true;
    },
    normalizarCategoria(categoria) {
      const contagem = categoria.contagem_itens || {};

      return {
        ...categoria,
        allItens: [],
        total_itens: contagem.total_itens || 0,
        pagina: 1,
        paginaCarregada: 0,
        carregando: false,
        completo: false,
        aberta: false,
      };
    },
    // A preferência salva em ocultarCategoria só fecha categoria, nunca abre: no cardápio
    // antigo o valor era alternado a cada clique, então um false gravado significa apenas
    // "já foi reaberta uma vez". Era isso que fazia categorias aleatórias aparecerem
    // expandidas sozinhas, cada uma ainda disparando uma requisição de itens.
    definirEstadoInicialCategorias(catalogoGrande) {
      // Catálogo grande abre só a primeira categoria da ordem exibida — a mesma ordem do
      // orderBy do template — para a tela não abrir vazia nem carregar tudo de uma vez.
      const primeira = catalogoGrande ? _.orderBy(this.categorias, ["indice"], ["asc"])[0] : null;

      this.categorias.forEach(categoria => {
        if (this.ocultarCategoria[categoria.id] === true) {
          categoria.aberta = false;
          return;
        }

        categoria.aberta = catalogoGrande ? !!primeira && categoria.id === primeira.id : true;
      });
    },
    async carregarCatalogoCompleto() {
      const response = await this.$axios.get("/catalogo/item", {
        params: {
          catalogo_id: this.catalogo.id,
          status: 2,
        },
      });

      const porCategoria = _.groupBy(response.data, "categoria_id");

      this.categorias.forEach(categoria => {
        categoria.allItens = porCategoria[categoria.id] || [];
        categoria.total_itens = categoria.allItens.length;
        categoria.pagina = 1;
        categoria.completo = true;
      });
    },
    async buscar(termo) {
      const busca = termo ? String(termo).trim() : "";

      if (busca.length < MIN_CARACTERES_BUSCA || !this.catalogo) {
        this.resultadoBusca = null;
        this.buscando = false;
        return;
      }

      const token = ++this.buscaToken;
      this.buscando = true;

      try {
        const response = await this.$axios.get("/catalogo/item", {
          params: {
            catalogo_id: this.catalogo.id,
            status: 2,
            busca,
          },
        });

        if (token !== this.buscaToken) {
          return;
        }

        this.resultadoBusca = _.groupBy(response.data, "categoria_id");

        const semResultado = this.list.filter(categoria => !this.resultadoBusca[categoria.id]);
        await Promise.all(
          semResultado.map(categoria => this.carregarPagina(categoria, categoria.pagina))
        );
      } catch (error) {
        let err =
          error.response && error.response.data
            ? error.response.data.error
            : "Ocorreu um erro ao buscar os itens. Tente novamente!";
        window.getApp.$emit("APP_ALERT", { color: "red", text: err });
      } finally {
        if (token === this.buscaToken) {
          this.buscando = false;
        }
      }
    },
    verifyPromoSpecialItem(item) {
      return item.especial && item.promocional ? true : false;
    },
    showMsgPromoSpecial(categoria) {
      if (!categoria)
        return window.getApp.$emit("APP_ALERT", {
          color: "orange",
          text:
            "Não é possível executar a ação pois este item está participando de uma promoção especial!",
        });

      return window.getApp.$emit("APP_ALERT", {
        color: "orange",
        text:
          "Não é possível executar a ação pois existe um item ativo participando de uma promoção especial!",
      });
    },
    itemVigente(item) {
      return (
        !item.data_inicio ||
        !item.data_fim ||
        (this.$dayjs(item.data_inicio).isSameOrBefore(this.$dayjs()) &&
          this.$dayjs(item.data_fim).isSameOrAfter(this.$dayjs()))
      );
    },
    categoriaVigente(categoria) {
      return (
        categoria.data_inicio_desconto &&
        categoria.data_fim_desconto &&
        this.$dayjs(categoria.data_inicio_desconto).isSameOrBefore(
          this.$dayjs()
        ) &&
        this.$dayjs(categoria.data_fim_desconto).isSameOrAfter(this.$dayjs())
      );
    },
    async temItemPromocaoEspecialAtivo(categoria) {
      try {
        const response = await this.$axios.get("/catalogo/item", {
          params: {
            categoria_id: categoria.id,
            status: 2,
            especial: 1,
            ativo: 1,
          },
        });

        return response.data.some(item => this.verifyPromoSpecialItem(item));
      } catch (error) {
        const item = _.find(categoria.allItens, this.verifyPromoSpecialItem);

        return !!(item && item.ativo == 1);
      }
    },
    async ativarCategoria(categoria) {
      if (await this.temItemPromocaoEspecialAtivo(categoria)) {
        return this.showMsgPromoSpecial(true);
      }

      const novoAtivo = categoria.ativo == 0 ? 1 : 0;
      const categoriaPost = { ..._.cloneDeep(categoria), ativo: novoAtivo };

      this.loading = true;
      try {
        await this.$axios.put("/catalogo/categoria", categoriaPost);

        this.categorias = this.categorias.map(cat =>
          cat.id === categoria.id ? { ...cat, ativo: novoAtivo } : cat
        );

        window.getApp.$emit("APP_ALERT", {
          color: "success",
          text: "Categoria atualizada com sucesso!",
        });
      } catch (error) {
        let err =
          error.response && error.response.data
            ? error.response.data.error
            : "Ocorreu um erro ao atualizar a categoria. Tente novamente!";
        window.getApp.$emit("APP_ALERT", { color: "red", text: err });
      }
      this.loading = false;
    },
    async ativarItem(item) {
      console.log("Função de ativar");
      if (this.verifyPromoSpecialItem(item)) return this.showMsgPromoSpecial();

      const ItemPost = _.cloneDeep(item); //

      ItemPost.ativo = 1;
      ItemPost.disponivel = 1;
      ItemPost.data_disponivel = "NULL";
      this.loading = true;

      try {
        const response = await this.$axios.put("/catalogo/item", ItemPost);
        item.ativo = 1;
        item.disponivel = 1;
        item.data_disponivel = "NULL";
        this.refreshList(ItemPost)

        window.getApp.$emit("APP_ALERT", {
          color: "success",
          text: "Item atualizado com sucesso!",
        });


      } catch (error) {
        let err =
          error.response && error.response.data
            ? error.response.data.error
            : "Ocorreu um erro ao atualizar o item. Tente novamente!";
        window.getApp.$emit("APP_ALERT", { color: "red", text: err });
      }
      this.loading = false;
    },
    async arquivarItem(item) {
      if (this.verifyPromoSpecialItem(item)) return this.showMsgPromoSpecial();
      const backupItem = _.cloneDeep(item);

      item.ativo = 0;
      item.data_disponivel = null;
      item.arquivado = 1;

      this.loading = true;

      try {
        const possoDeletar = await this.$confirm(
          "Tem certeza de que quer deletar este item?<br><b>Essa ação não poderá ser desfeita.</b>",
          { title: "Atenção" }
        );
        if (!possoDeletar) {
          this.loading = false;
          return;
        }
        const response = await this.$axios.put("/catalogo/item", item);
        window.getApp.$emit("APP_ALERT", {
          color: "success",
          text: "Item deletado com sucesso!",
        });
        this.removerItemLocal(item);
      } catch (error) {
        let err =
          error.response && error.response.data
            ? error.response.data.error
            : "Ocorreu um erro ao deletar o item. Tente novamente!";
        window.getApp.$emit("APP_ALERT", { color: "red", text: err });

        item.ativo = backupItem.ativo;
        item.disponivel = backupItem.disponivel;
        item.data_disponivel = backupItem.data_disponivel;
        item.arquivado = backupItem.arquivado;
      }
      this.$forceUpdate();
      this.loading = false;
    },
    encontrarItemCarregado(id) {
      const carregados = _.flatMap(this.categorias, "allItens");
      const doResultado = this.resultadoBusca
        ? _.flatten(Object.keys(this.resultadoBusca).map(chave => this.resultadoBusca[chave]))
        : [];

      return _.find(carregados.concat(doResultado), { id });
    },
    podeDuplicarItemSelecionado() {
      if (!this.editarCardapio || !this.$root.user.permissao_cardapio) return false;
      if (!this.itemSelecionado || this.cadastroAtual != 2) return false;

      return !!this.encontrarItemCarregado(this.itemSelecionado);
    },
    async duplicarItemSelecionado() {
      const item = this.encontrarItemCarregado(this.itemSelecionado);

      if (!item) return;
      if (item.especial == 1) return this.showMsgPromoSpecial();

      const confirmado = await this.$confirm(
        `Será criado um novo item com as mesmas configurações e complementos de <b>${_.escape(item.nome)}</b>.<br>Deseja continuar?`,
        { title: "Duplicar item" }
      );
      if (!confirmado) return;

      this.duplicando = true;

      try {
        const { data } = await this.$axios.post("/item-catalogo/duplicar", {
          item: _.omit(item, ["variacoes"]),
        });
        const copia = _.omit(data, ["variacoes"]);
        const categoria = _.find(this.categorias, { id: item.categoria_id });

        this.inserirCopiaLocal(copia, item, categoria);
        this.registrarLogDuplicacao(item, copia);

        window.getApp.$emit("APP_ALERT", {
          color: "success",
          text: "Item duplicado com sucesso!",
        });

        if (categoria) {
          this.isClicked = copia.id;
          this.openDialogItem(copia, categoria);
        }
      } catch (error) {
        let err =
          error.response && error.response.data
            ? error.response.data.error
            : "Ocorreu um erro ao duplicar o item. Tente novamente!";
        window.getApp.$emit("APP_ALERT", { color: "red", text: err });
      } finally {
        this.duplicando = false;
      }
    },
    inserirCopiaLocal(copia, original, categoria) {
      if (!categoria) return;

      categoria.total_itens = (categoria.total_itens || 0) + 1;

      if (categoria.completo) {
        const indice = categoria.allItens.findIndex(atual => atual.id == original.id);
        categoria.allItens.splice(indice + 1, 0, copia);
      } else {
        this.carregarPagina(categoria, categoria.pagina, { forcar: true });
      }

      const resultados = this.resultadoBusca ? this.resultadoBusca[categoria.id] : null;

      if (resultados) {
        const indice = resultados.findIndex(atual => atual.id == original.id);
        resultados.splice(indice + 1, 0, copia);
      }
    },
    registrarLogDuplicacao(original, copia) {
      this.$axios.post("/log", {
        estabelecimento_id: this.estabelecimentoSelecionado.id,
        admin_estabelecimento_id: this.$root.user.id,
        registro: "CARDAPIO",
        alteracao: `Duplicou o item "${original.nome}" (${original.id}) gerando o item ${copia.id} no gestor de pedidos web`,
      }).catch(error => console.log(error));
    },
    canShareSelectedItem() {
      if (!this.itemSelecionado || this.cadastroAtual != 2) return false;

      const item = this.encontrarItemCarregado(this.itemSelecionado);

      return !!item && this.isAtivo(item);
    },
    async shareSelectedItem() {
      const item = this.encontrarItemCarregado(this.itemSelecionado);

      if (!item) return;

      const link = this.$root.getURL(this.estabelecimentoSelecionado, item.id);

      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(link);
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = link;
          textarea.setAttribute("readonly", "");
          textarea.style.position = "absolute";
          textarea.style.left = "-9999px";
          document.body.appendChild(textarea);
          textarea.select();
          const copied = document.execCommand("copy");
          document.body.removeChild(textarea);
          if (!copied) throw new Error("copy-failed");
        }

        window.getApp.$emit("APP_ALERT", {
          color: "success",
          text: "Link do item copiado com sucesso!",
        });
      } catch (error) {
        window.getApp.$emit("APP_ALERT", {
          color: "red",
          text: "Não foi possível copiar o link. Tente novamente.",
        });
      }
    },
  },
};
</script>

<style scoped>
.Poppins {
  font-family: "Poppins", "Roboto", "Helvetica";
}
.br-5{
  border-radius: 5px !important;
}
.br-10{
  border-radius: 10px !important;
}
.verdeCategoria {
  background-color: rgba(50, 50, 50, 0.1);
}
.vermelhoCategoria {
  background-color: #ffb0b0;
  border-radius: 10px 10px 0px 0px !important;
  border-top: 1px solid #da8e8e !important;
  border-left: 1px solid #da8e8e !important;
  border-right: 1px solid #da8e8e !important;
}

.vermelhoCategoriaFechada {
  background-color: #ffb0b0;
  border-radius: 10px 10px 10px 10px !important;
  border-top: 1px solid #da8e8e !important;
  border-left: 1px solid #da8e8e !important;
  border-right: 1px solid #da8e8e !important;
}

.vermelhoItem {
  background-color: rgba(255, 15, 0, 0.2);
  border-right: 1px solid #da8e8e !important;
  border-left: 1px solid #da8e8e !important;
}
.circulating-border {
  background-image: linear-gradient(90deg, #1d9a5a 50%, transparent 50%),
    linear-gradient(90deg, #1d9a5a 50%, transparent 50%),
    linear-gradient(0deg, #1d9a5a 50%, transparent 50%),
    linear-gradient(0deg, #1d9a5a 50%, transparent 50%);
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size: 15px 2px, 15px 2px, 2px 15px, 2px 15px;
  background-position: left top, right bottom, left bottom, right top;
  animation: border-dance 0.6s infinite linear;
}
@keyframes border-dance {
  0% {
    background-position: left top, right bottom, left bottom, right top;
  }
  100% {
    background-position: left 15px top, right 15px bottom, left bottom 15px,
      right top 15px;
  }
}

.Capitalize {
  text-transform: capitalize;
}
.promocional {
  text-decoration: line-through !important;
}
.custom-color {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin-right: 5px;
  border-radius: 5px;
}
.botaoHover {
  color: #111312cc;
  background-color: #eaeaea !important;
  text-transform: capitalize;
}
.botaoEdicao {
  color: #111312cc;
  text-transform: capitalize;
}
.botaoCompartilhar,
.botaoDuplicar {
  color: #111312cc;
  text-transform: capitalize;
  background-color: #fff!important;
}
.botaoCompartilhar:hover,
.botaoDuplicar:hover {
  background-color: #dddddd!important;
}
.introbotaoHover {
  color: #111312cc;
  background-color: #c7c7c7 !important;
  text-transform: capitalize;
}
.botaoHover:hover {
  background-color: #e3f0e9 !important ;
}
.botaoHover:hover .introbotaoHover {
  background-color: #1d9a5a !important;
}
.botaoHover:hover .introbotaoHover i {
  color: #fff !important;
}
.botaoAdicionarCategoria {
  padding: 0 !important;
  margin: 0 12px;
  border-radius: 6px;
  color: #fff;
  min-height: 50px;
  font-size: 17px;
  font-weight: bold;
  text-transform: capitalize;
  float: left;
}
.btnDeletar {
  position: absolute;
  display: flex;
  align-items: center;
  top:50%;
  left: 92%;
  transform: translate(-50%, -50%);
}
.iconAdicionarCategorias {
  transform: rotate(0deg);
}
.botaoAdicionarCategoria:hover .iconAdicionarCategorias {
  transform: rotate(360deg);
}
.botaoAdicionarItem {
  z-index: 9999;
  border-radius: 5px;
}
.botaoAdicionarItem:hover {
  background-color: #1d9a5a;
  color: #fff !important;
}
.rotate-180 {
  transform: rotate(180deg);
}

.rotate-0 {
  transform: rotate(0deg);
}
.transformation{
  -moz-transform: translateY(-1px);
  -o-transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
  transform: translateY(-1px);
}
.btnReordenar{
  font-size:12px;
  -moz-transform: translateY(-1px);
  -o-transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
  transform: translateY(-2.5px) rotate(90deg);
}
.iconSetaPraCima{
  font-size:12px;
  -moz-transform: translateY(-1px);
  -o-transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
  transform: translateX(3px) translateY(-2px) rotate(45deg);
}
.areaAddCategoria{
  justify-content: flex-start;
  display: flex;
  flex-flow:column wrap;
  align-content: stretch;
  align-items: stretch;
}
.caixaDoItem{
  border: 2px solid rgba(17, 19, 18, 0.2);
  padding: 0px !important;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow:none !important;
}
.cardDoItem{
  height: 80vh;
  box-shadow:none !important;
  background-color:#fafafa !important;
}
.caixaDoLoading{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80vh;
  }

  .tagsIntegrado{
    transform: translateY(-30px);
  }
.areaSalvar{
  position: fixed;
  top: calc(100vh - 120px);
  width: 80vw;
  height: 120px;
  z-index: 9999;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}
.areaSalvar:before{
  content: '';
  position: absolute;
  background-color: #ffffff03;
  mask: linear-gradient(180deg,rgba(0,0,0,0) 76%,rgba(0,0,0,1) 100%) add;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  pointer-events: none;
}
.areaSalvar:after{
  content: '';
  position: absolute;
  background-color: #ffffff03;
  width: 100%;
  height: 100%;
  mask: linear-gradient(180deg,rgba(0,0,0,0) 50%,rgba(0,0,0,1) 75%) add;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  pointer-events: none;
}
.areaSalvarMobile{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100vw;
  height: 80px;
  z-index: 200;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.botaoSalvarGeral {
  padding: 10px 30px;
  margin: 2px 10px;
  border-radius: 10px;
  color: #fff;
  min-height: 56px;
  font-size: 17px;
  font-weight: bold;
  text-transform: capitalize;
  float: right;
  z-index: 9999;
  pointer-events: auto;
}
.botaoFecharGeral{
  padding: 10px 20px;
  margin: 2px 10px;
  border-radius: 6px;
  color: #0000006e;
  min-height: 50px;
  font-size: 17px;
  border: 2px solid #0000006e!important;
  font-weight: bold;
  text-transform: capitalize;
  float: right;
  z-index: 9999;
}

</style>
<style type="text/css">

.no-scroll {
  overflow: hidden!important;
}

</style>
